enum DepositTransactionContent {
  PAY = 'PAY',
  PUT_ADMIN = 'PUT_ADMIN',
  PUT_VBANK = 'PUT_VBANK',
  WITHDRAW = 'WITHDRAW',
  REFUNDED = 'REFUNDED',
}

export default DepositTransactionContent;
